module.exports = __webpack_public_path__ + "img/62.f360c2f1.svg";